<template>
  <div class="mx-0">
    <shortcut />
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0 px-1">
          <v-col
            cols="12"
            md="3"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="from"
                :label="$t('startDate')"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="from"
                element="fromId"
                :locale="$store.state.date_locale"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="to"
                :label="$t('endDate')"
                :rules="[v => !!v || $t('is-required')]"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="to"
                element="toId"
                :locale="$store.state.date_locale"
                :min="from"
                auto-submit
                clearable
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0 ">
            <v-col
              cols="6"
              class="px-0 pb-1"
            >
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              class="px-0 pb-1"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('close') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Shortcut from './partial/shortcut'
  export default {
    name: 'NewCustomerW',
    components: {
      Shortcut,
    },
    mixins: [General],
    props: ['startProp', 'endProp', 'planProp', 'color'],
    data: () => ({
      filter: false,
      loading: false,
      from: null,
      to: null,
      plan: null,
      count: null,
      snackbar: false,
      snakbarText: null,
      snakbarColor: null,
    }),
    watch: {
    },
    mounted  () {
      this.getItems()
    },
    methods: {
      getItems () {
        var app = this
        app.loading = true
        app.filter = false
        app.$axios.get(this.$endpoint + 'widgets', {
          params: {
            type: 'newCustomer',
            lead: null,
            start: (app.startProp ? app.startProp : app.from),
            end: (app.endProp ? app.endProp : app.to),
            plan: (app.planProp ? app.planProp : app.plan),
          },
        })
          .then(res => {
            res = res.data
            app.count = res
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            app.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.v-progress-circular {
  margin: 4px;
}
</style>
